/**
 * Wizard Page
 *
 * Renders the TurboTax-style guided permit intake wizard.
 */

import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { WizardContainer } from '@/components/wizard';
import { Loader2 } from 'lucide-react';

const Wizard = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();

  // Redirect to auth if not logged in
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    navigate('/auth');
    return null;
  }

  // Handle wizard completion
  const handleComplete = (projectId: string, jobIds: string[]) => {
    // Navigate to the first created job
    if (jobIds.length > 0) {
      navigate(`/jobs/${jobIds[0]}`);
    } else {
      navigate('/permits');
    }
  };

  // Handle cancel
  const handleCancel = () => {
    navigate('/permits');
  };

  return (
    <WizardContainer
      onComplete={handleComplete}
      onCancel={handleCancel}
    />
  );
};

export default Wizard;
